var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetterExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 20,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 52.5C26.675 52.5 25.969 52.2065 25.382 51.6195C24.795 51.0325 24.501 50.326 24.5 49.5V22.5C24.5 21.675 24.794 20.969 25.382 20.382C25.97 19.795 26.676 19.501 27.5 19.5H42.5C43.325 19.5 44.0315 19.794 44.6195 20.382C45.2075 20.97 45.501 21.676 45.5 22.5V27.15C45.95 27.325 46.3125 27.6 46.5875 27.975C46.8625 28.35 47 28.775 47 29.25V32.25C47 32.725 46.8625 33.15 46.5875 33.525C46.3125 33.9 45.95 34.175 45.5 34.35V49.5C45.5 50.325 45.2065 51.0315 44.6195 51.6195C44.0325 52.2075 43.326 52.501 42.5 52.5H27.5ZM27.5 49.5H42.5V22.5H27.5V49.5ZM35 48C35.425 48 35.7815 47.856 36.0695 47.568C36.3575 47.28 36.501 46.924 36.5 46.5C36.499 46.076 36.355 45.72 36.068 45.432C35.781 45.144 35.425 45 35 45C34.575 45 34.219 45.144 33.932 45.432C33.645 45.72 33.501 46.076 33.5 46.5C33.499 46.924 33.643 47.2805 33.932 47.5695C34.221 47.8585 34.577 48.002 35 48Z",
    fill: "url(#paint0_linear_1471_7253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1471_7253",
    x1: 24.5,
    y1: 36,
    x2: 47,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterExperience);
export default __webpack_public_path__ + "static/media/Better Experience.24bc729600d7b9cb1810ef0e5a6c12f9.svg";
export { ForwardRef as ReactComponent };